import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NotificationService } from '@app/dialog/services';
import { EventUserRegistration, Events } from '@app/events/models';
import { EventService } from '@app/events/services';
import { FetchEventUserRegistrations, FetchEvents } from '@app/events/store/events.actions';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable, catchError, of, tap } from 'rxjs';

export interface EventsStateModel {
  events?: Events;
  userRegistrations?: EventUserRegistration[];
}

@State<EventsStateModel>({
  name: 'events',
  defaults: {},
})
@Injectable()
export class EventsState {
  constructor(
    private eventService: EventService,
    private notificationService: NotificationService
  ) {}

  @Selector()
  static getEvents(state: EventsStateModel): Events | undefined {
    return state.events;
  }

  @Action(FetchEvents)
  fetchEvents(ctx: StateContext<EventsStateModel>, action: FetchEvents): Observable<Events | undefined> | undefined {
    const { events } = ctx.getState();

    if (events && !action.force) {
      return;
    }

    return this.eventService.getEvents().pipe(
      tap((data) => {
        ctx.patchState({ events: data });
      }),
      catchError((error: HttpErrorResponse) => {
        this.notificationService.openAsError(error.error?.Description || 'EVENTS.FAILED_TO_FETCH_EVENTS');
        return of(undefined);
      })
    );
  }

  @Selector()
  static getEventUserRegistrations(state: EventsStateModel): EventUserRegistration[] | undefined {
    return state.userRegistrations;
  }

  @Action(FetchEventUserRegistrations)
  fetchEventUserRegistrations(
    ctx: StateContext<EventsStateModel>,
    action: FetchEventUserRegistrations
  ): Observable<EventUserRegistration[] | undefined> | undefined {
    const { userRegistrations } = ctx.getState();

    if (userRegistrations && !action.force) {
      return;
    }

    return this.eventService.getUserEventRegistrations().pipe(
      tap((data) => {
        ctx.patchState({ userRegistrations: data });
      }),
      catchError((error: HttpErrorResponse) => {
        this.notificationService.openAsError(error.error?.Description || 'EVENTS.FAILED_TO_FETCH_EVENT_REGISTRATIONS');
        return of(undefined);
      })
    );
  }
}
